import React from 'react';

export const PageLoader = () => <div>Loading</div>;
